const DELETE_ERROR_MESSAGES: Record<string, string> = {
  deal_delete_auth_required: 'Sign in again, then try deleting this contact.',
  deal_delete_requires_tpb_admin: 'Only TPB admins can delete lost-deal contacts.',
  deal_delete_not_found: 'That contact was already removed.',
  deal_delete_not_closed_lost: 'Only Closed Lost contacts can be removed from this list. Opt out or edit the deal instead.',
  deal_delete_has_location: 'This deal is linked to a location. Opt the contact out of Track B instead of deleting.',
  deal_delete_has_quotes_or_invoices: 'This deal has quotes or invoices. Opt the contact out of Track B instead of deleting.',
  deal_delete_has_conversion_attempt: 'This deal has a location conversion record. Opt the contact out of Track B instead of deleting.',
  deal_delete_converted_from_lead: 'This deal was converted from a lead. Opt the contact out of Track B instead of deleting.',
  deal_delete_has_pulse_delivery: 'This contact is already in a Network Pulse send. Opt them out instead of deleting.',
  network_pulse_renderer_v3_delivery_disabled:
    'Network Pulse still holds this contact. Opt them out of Track B, or retry after the delete helper is applied.',
};

const DELETE_ERROR_CODES = Object.keys(DELETE_ERROR_MESSAGES);

export function formatClosedLostDeleteError(error: unknown): string {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'object' && error && 'message' in error
        ? String((error as { message: unknown }).message)
        : String(error ?? '');

  const matchedCode = DELETE_ERROR_CODES.find((code) => message.includes(code));
  if (matchedCode) {
    return DELETE_ERROR_MESSAGES[matchedCode] ?? 'Could not delete this contact.';
  }

  if (/foreign key|violates foreign key/i.test(message) || message.includes('23503')) {
    return 'This contact is linked to other records. Opt them out of Track B instead of deleting.';
  }

  if (/Could not find the function|schema cache/i.test(message)) {
    return 'Delete is not available on this database yet. Apply the latest Deals migration, or opt the contact out for now.';
  }

  const trimmed = message.replace(/^Failed to delete deal:\s*/i, '').trim();
  return trimmed && trimmed !== 'Failed to delete deal'
    ? `Could not delete this contact: ${trimmed}`
    : 'Could not delete this contact. Opt them out of Track B if they should not receive mail.';
}

export function isMissingDeleteRpc(error: { message?: string; code?: string } | null): boolean {
  if (!error) return false;
  const message = error.message ?? '';
  return (
    error.code === 'PGRST202' ||
    error.code === '42883' ||
    /Could not find the function|schema cache/i.test(message)
  );
}
